import React from 'react';

const ML_Examples = () => {
    return (
        <div>ML_Examples Component</div>
    );
}

export default ML_Examples;
